import type { WhatsAppTemplateData } from '@jobilla/nexus-sdk'

function isBodyComponent(value: unknown): value is { type: 'BODY'; text: string } {
	return typeof value === 'object'
		&& value !== null
		&& (value as { type?: unknown }).type === 'BODY'
		&& typeof (value as { text?: unknown }).text === 'string'
}

// components can arrive as objects or JSON strings — mirror the canonical
// parse in whatsapp-thread's mapApiTemplateToWhatsAppTemplate.
export function getTemplateBodyText(template: WhatsAppTemplateData): string {
	for (const componentJson of template.components) {
		try {
			const parsed: unknown = typeof componentJson === 'string' ? JSON.parse(componentJson) : componentJson
			if (isBodyComponent(parsed)) {
				return parsed.text
			}
		} catch {
			// skip invalid JSON
		}
	}
	return ''
}
